import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const faSaltShaker: IconDefinition = {
  prefix: 'fak',
  iconName: 'salt-shaker',
  icon: [
    384,
    512,
    [],
    '',
    'M96 192V160C96 96 140 48 192 48S288 96 288 160V192Z' +
      'M136 128a16 16 0 1 0 32 0a16 16 0 1 0-32 0Z' +
      'M176 100a16 16 0 1 0 32 0a16 16 0 1 0-32 0Z' +
      'M216 128a16 16 0 1 0 32 0a16 16 0 1 0-32 0Z' +
      'M80 208H304V248H80Z' +
      'M96 264H288L320 448Q326 488 286 488H98Q58 488 64 448Z' +
      'M118 296L104 380H280L266 296Z',
  ],
};

export default faSaltShaker;
